import React, { useEffect, useState } from "react";
import PanelError from "../PanelError";
import ButtonRestartApp from "../ButtonRestartApp";
import PageContent from "../PageContent";
import { useDispatch, useSelector } from "react-redux";
import { applicationContinue } from "../../logic/actions/api/application";
import { go } from "../../logic/actions/navigation";
import { logEvent, SWITCHED_TO_MOBILE } from "../../logic/eventLogger";
import { FACE_CAPTURE_INSTRUCTIONS } from "../../logic/enums/pages";

export default function ApplicationContinue({ children }) {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const tenant = useSelector((state) => state.configuration.tenant);
  
  useEffect(() => {
    const parameters = new URLSearchParams(window.location.search);
    const code = parameters.get("code");
    const phone = parameters.get("phone");
    if (code && phone) {
      logEvent(SWITCHED_TO_MOBILE);

      //removes parameters from the url
      window.history.replaceState(
        {},
        document.title,
        tenant ? `/${tenant}/start` : "/start"
      );
      applicationContinue(
        `+${Number(phone)}`,
        code
      )(dispatch)
        .then(() => {
          setLoaded(true);
          go(FACE_CAPTURE_INSTRUCTIONS)(dispatch);
        })
        .catch((err) => {
          setError("Failed to switch to mobile. Check if your link is correct");
        });
    } else {
      setLoaded(true);
    }
  }, [dispatch, tenant]);

  if (loaded) return children;

  if (error)
    return (
      <PageContent>
        <PanelError text={error} />
        <ButtonRestartApp />
      </PageContent>
    );

  return (
    <PageContent showVersion={true}>
      <header />
      <h1>Switching to mobile...</h1>
    </PageContent>
  );
}
